module.exports = require("./../../_gen/starling/text/TextOptions");